import React from "react";

const JoinUsSection = () => {
  return (
    <section className="py-16 bg-green-50 text-center">
      <h2 className="text-3xl font-bold mb-6">Join FV Plus AgroTech Innovations</h2>
      <div className="flex justify-center">
        <img
          src="path-to-join-us-image.jpg"
          alt="Join Us"
          className="w-96 rounded-full shadow-md"
        />
      </div>
    </section>
  );
};

export default JoinUsSection;
